import { Genders } from 'Constants/index';
import { _config } from './envConfig';
import i18n from './i18n';
import { getSessionObject } from './storage';
/** Reference used to store urls */
export const urls = {
  libreSharingApiUrl: '',
  libreSharingApiCountryUrl: ''
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config, country) => {
  const {
    libreSharingApiUrl,
    libreSharingApiCountryUrls
  } = config;
  Object.assign(urls, {
    libreSharingApiUrl,
    libreSharingApiCountryUrl: country && libreSharingApiCountryUrls ? libreSharingApiCountryUrls[country] : libreSharingApiUrl
  });
};
export const getDocumentPathFromLanguage = (document, lang) => {
  if (!document) {
    return '';
  }
  const path = document[lang.toLowerCase()] || document.default || document['en-us'];
  return path;
};
export const detectTheme = urlParams => {
  const productParam = urlParams.get('product');

  // temporarily disabled dark mode
  // const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'Dark' : 'Light';
  const theme = 'Light';
  return !productParam || productParam === 'libre1' ? `polaris${theme}` : `otc${theme}`;
};
export const getTheme = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const themeParam = urlParams.get('theme');
  return themeParam ? themeParam : detectTheme(urlParams);
};
export const generateUserAgentHeader = (app, appVersion, osType, osVersion) => {
  return `${app ? app : 'none'};${appVersion ? appVersion : 'none'};${osType ? osType : 'none'};${osVersion ? osVersion : 'none'}`;
};
export const validateFrenchZipCode = zipCode => {
  if (!zipCode) {
    return false;
  }
  const regex = new RegExp(/^\d{5}$/);
  return regex.test(zipCode);
};
export const getGenderDisplayText = gender => {
  if (!gender) {
    return '';
  }
  const cmsKey = gender === Genders.UNDETERMINED ? 'other' : gender;
  return i18n.t(`Global.microcopy.genderOptions.${cmsKey}`);
};
export const isBypassPhoneNumberEnabled = () => {
  return Boolean(_config.environment !== 'production' && getSessionObject('isBypassPhoneNumberEnabled'));
};